/**
 * @desc 根据产品材质编号查询
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.ProductMaterialResponseDto>;
export function request(materialNo: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productMaterial/byUnique/${materialNo}`, {
      method: "GET",

      ...options,
    }),
  );
}
